import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { createSessionAuthClient } from './auth/session'
import { applyTheme, readThemePreference } from './design/theme'
import { deviceStorage, initTypeScale } from './design/typeScale'
import './design/tokens.css'
import './design/components.css'
import './design/ledger.css'
import './auth/auth.css'
import './session/session.css'
import './shell/shell.css'
import './features/status/status.css'
import './features/queue/queue.css'
import './features/item/item.css'
import './features/suggestion/suggestion.css'
import './features/reply/reply.css'
import './features/reclassify/reclassify.css'
import './features/knowledge/knowledge.css'
import './features/corpus/corpus.css'
import './features/usage/usage.css'
import './features/settings/settings.css'
import './features/password/password.css'
import './features/operations/operations.css'
import './features/live/live.css'
import { CONSOLE_ENV } from './env'
import { takeRequestedTenant } from './session/requestedTenant'

const preferences = deviceStorage()

applyTheme(document.documentElement, readThemePreference(preferences))
initTypeScale(document.documentElement, preferences)

const container = document.getElementById('root')
if (container === null) throw new Error('找不到 #root 容器')

const auth = createSessionAuthClient({ baseUrl: CONSOLE_ENV.apiBaseUrl })
const requestedTenantId = takeRequestedTenant(window)

createRoot(container).render(
  <StrictMode>
    <App auth={auth} baseUrl={CONSOLE_ENV.apiBaseUrl} requestedTenantId={requestedTenantId} />
  </StrictMode>,
)
